import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { UserSVG } from '../svg/user.svg';

const UserIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <UserSVG/>
    </div>
  );
};

export { UserIcon };
